module.exports = __webpack_public_path__ + "static/media/Arvo-Regular.31c017da.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Arvo-Regular.ttf
// module id = 2829
// module chunks = 51